/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

// import styles
import { toast } from 'react-toastify';
import useStyles from '../../assets/styles/components/selectStateAndCity';
import { ReactComponent as IconArrow } from '../../assets/images/svg/utils/icon_arrow.svg';
import { api } from '../../services';
import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';

import { useLoadingContext } from '../../providers/use-loading';
import { useSelectedStateCityContext } from '../../providers/use-selected-state-city';
import { coordinates } from '../../helpers/utils/locationCoordinates';

type PCidade = {
  dsCidade: string;
  dsCidadeUrlSlug: string;
  dsGoogleAnalytics: string;
  dsGoogleTagManager: string;
  idCidade: string;
  idMarketplace: string;
  idMetaPixel: string;
};

const SelectStateAndCity: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const { createSelected } = useSelectedStateCityContext();

  const [stateSelected, setStateSelected] = useState<number>(0);
  const [stateList, setStateList] = useState<any>();
  const [cityList, setCityList] = useState<any>();

  const selectedCity = async (data: PCidade) => {
    createloading(true);

    if (
      stateSelected > 0 &&
      parseInt(data.idCidade, 10) > 0 &&
      parseInt(data.idMarketplace, 10) > 0 &&
      data.dsCidade !== ''
    ) {
      const { lat, lng } = await coordinates();

      localStorage.setItem(
        '@mais/delivery/dataStateCity',
        JSON.stringify({
          dsCidade: data.dsCidade,
          idMarketplace: data.idMarketplace,
          idCidade: data.idCidade,
          idEstado: stateSelected,
          lat,
          lng,
        }),
      );
      localStorage.setItem(
        '@mais/delivery/dataStateCity/GA/GMT/PXL',
        JSON.stringify({
          idMetaPixel: data.idMetaPixel,
          dsGoogleTagManager: data.dsGoogleTagManager,
          dsGoogleAnalytics: data.dsGoogleAnalytics,
        }),
      );
      createloading(false);
      createSelected(true);
      window.location.reload();
    } else {
      createloading(false);
      setStateSelected(0);
      toast.error(
        'Ocorreu um erro ao selecionar estado e cidade, tente novamente',
      );
    }
  };

  const handleListState = async () => {
    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.listState({
          nr_operacao: 13,
        });

      setStateList(result.data);
      createloading(false);
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao listar os estados');
    }
  };

  const handleListCity = async () => {
    try {
      createloading(true);

      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.listCityState({
          nr_operacao: 14,
          tpCidades: 2,
          idEstado: stateSelected,
        });

      setCityList(result.data);
      createloading(false);
    } catch (error) {
      createloading(false);

      toast.error('Ocorreu um erro ao listar os cidades');
    }
  };

  useEffect(() => {
    handleListState();
  }, []);

  useEffect(() => {
    if (stateSelected) {
      handleListCity();
    }
  }, [stateSelected]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      {stateList && (
        <Grid container item textAlign="center" justifyContent="center">
          {!stateSelected ? (
            <>
              <Grid
                container
                item
                textAlign="center"
                justifyContent="center"
                xs={12}
                className={classeStyle.content}
              >
                <h3 className={classeStyle.title}>Selecione o Estado</h3>
              </Grid>
              <Grid
                container
                item
                textAlign="center"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  sx={{
                    width: '100%',
                    height: 350,
                  }}
                >
                  <List
                    sx={{
                      width: '100%',
                      bgcolor: 'background.paper',
                      position: 'relative',
                      overflow: 'auto',
                      maxHeight: 350,
                      '& ul': { padding: 0 },
                    }}
                    subheader={<li />}
                  >
                    {stateList.map((data: any) => (
                      <li key={`${data.idEstado}`}>
                        <ul>
                          <ListItem
                            onClick={() =>
                              setStateSelected(parseInt(data.idEstado, 10))
                            }
                            className={classeStyle.gridNameCity}
                          >
                            <ListItemText
                              className={classeStyle.nameCity}
                              primary={`${data.dsEstado} - ${data.nmExtenso}`}
                            />
                            <IconArrow />
                          </ListItem>
                        </ul>
                      </li>
                    ))}
                  </List>
                </Box>
              </Grid>
            </>
          ) : (
            cityList && (
              <>
                <Grid
                  container
                  item
                  textAlign="center"
                  justifyContent="center"
                  xs={12}
                  className={classeStyle.content}
                >
                  <h3 className={classeStyle.title}>Selecione a Cidade</h3>
                </Grid>
                <Grid
                  container
                  item
                  textAlign="center"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: 350,
                    }}
                  >
                    <List
                      sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        maxHeight: 350,
                        '& ul': { padding: 0 },
                      }}
                      subheader={<li />}
                    >
                      {cityList.map((data: any) => (
                        <li key={`${data.idCidade}`}>
                          <ul>
                            <ListItem
                              onClick={() => selectedCity(data)}
                              className={classeStyle.gridNameCity}
                            >
                              <ListItemText
                                className={classeStyle.nameCity}
                                primary={`${data.dsCidade}`}
                              />
                              <IconArrow />
                            </ListItem>
                          </ul>
                        </li>
                      ))}
                    </List>
                  </Box>
                </Grid>
              </>
            )
          )}
        </Grid>
      )}
    </Container>
  );
};
export default SelectStateAndCity;
